import { NavLink, useParams } from "react-router-dom";
import BtnGitHub from "../components/btnGitHub/BtnGitHub";
import { projects } from "./../helpers/projectsList";

const Project = () => {
  const { id } = useParams();
  const index = Number(id);
  const project = Number.isInteger(index) ? projects[index] : undefined;

  if (!project) {
    return (
      <main className="section">
        <div className="container">
          <h1 className="title-1">Project not found</h1>
          <NavLink to="/projects" className="btn">
            Back to projects
          </NavLink>
        </div>
      </main>
    );
  }

  return (
    <main className="section">
      <div className="container">
        <div className="project-details">
          <h1 className="title-1">{project.title}</h1>

          <img
            src={project.imgBig}
            alt={project.title}
            className="project-details__cover"
          />
          <div className="project-details__desc">
            <p className="skills">Technologies: {project.skills}</p>
            <p>{project.description}</p>
          </div>
          <div className="project-details__links">
            <BtnGitHub link={project.gitHubLink} />
            {project.repoLink && <BtnGitHub link={project.repoLink} />}
          </div>
        </div>
      </div>
    </main>
  );
};

export default Project;
